<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold d-flex justify-content-between catalogo-text">
            Catálogo de actividades costos
            <!-- <router-link :to="{ name: 'Actividades' }">
              <CButton color="primary" class="mr-1">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>-->
          </CCardHeader>
          <CCardBody>
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="filteredItems"
              :fields="ubicaciones"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
              pagination
            >
              <template v-for="u in ubicaciones" :slot="u.key" slot-scope="{ item }">
                <td
                  v-if="item.tipo_pago"
                  @click="
                    toggleSelect(
                      JsonParse(item[u.key]).id,
                      JsonParse(item[u.key]).costo,
                      item.nombre,
                      u.label,
                      JsonParse(item[u.key]).act_id,
                      JsonParse(item[u.key]).ubi_id
                    )
                  "
                  :key="`u${u.key}${item.id}`"
                >{{ JsonParse(item[u.key]).costo }}</td>
                <td v-else :key="`u${u.key}${item.id}`"></td>
              </template>
              <template #over-table>
                <CInput v-model="filter" placeholder="Búsqueda por actividades..." />
              </template>
              <template #actividad="{item}">
                <td class="py-2">{{ item.nombre }}</td>
              </template>
              <template #unidad="{item}">
                <td class="py-2">{{ item.unidad }}</td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="modal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Costo Actividad"
      color="primary"
    >
      <CRow>
        <CCol sm="12">
          <CInput
            label="Costo de la actividad:"
            v-model="costo"
            append=".00"
            prepend="$"
            placeholder="Costo de la actividad"
            type="number"
            :value="itemModal.costo"
          ></CInput>
        </CCol>
      </CRow>
      <template #header>
        <h6 class="modal-title">{{ itemModal.nombre }} - {{ itemModal.ubicacion }}</h6>
        <CButtonClose @click="modal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton class="px-4" @click="modal = false" color="danger">Cancelar</CButton>
        <CButton class="px-4" @click="updateCosto()" color="success">Guardar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
export default {
  name: "ActividadesCostos",

  data() {
    return {
      items: [],
      fields: [],
      filter: "",
      actividades: [],
      actividadesAll: [],
      ubicaciones: [],
      ubicacionesAll: [],
      costo: null,
      modal: false,
      actividades_costo: [],
      isLoading: false,
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      itemModal: {
        id: "",
        costo: "",
        nombre: "",
        ubicacion: "",
        act_id: 0,
        ubi_id: 0
      }
    };
  },

  created() {
    this.isLoading = true;
    this.$store;

    const serv = [
      this.$store.dispatch("customHTTP", {
        schema: "actividades",
        filter: {
          where: [
            {
              field: "payload->tipo_pago",
              value: "variable",
              operator: "="
            }
          ]
        }
      }),
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->pertenece_id",
              value: 0,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      }),
      this.$store.dispatch("customHTTP", { schema: "actividades_costos" })
    ];

    Promise.all(serv)
      .then(([actividades, ubicaciones, actividades_costos]) => {
        this.items = actividades_costos.data;
        this.actividades = actividades.data.map(actividad => {
          return { value: actividad.id, label: actividad.payload.nombre };
        });

        this.ubicaciones = ubicaciones.data.map(ubicacion => {
          return {
            key: `ubicacion_${ubicacion.id}`,
            label: ubicacion.payload.nombre
          };
        });
        this.ubicaciones.unshift(
          { key: `actividad`, label: "Actividad" },
          { key: `unidad`, label: "Unidad" }
        );
        console.log(this.ubicaciones);

        this.ubicacionesAll = ubicaciones.data;
        this.actividadesAll = actividades.data
          ? actividades.data.filter(act => act.payload.tipo_pago != "fijo")
          : [];

        this.actividadesAll.map(act => {
          let ac = {
            id: act.id,
            nombre: act.payload.nombre,
            unidad: act.payload.unidad,
            tipo_pago: act.payload.tipo_pago
          };
          this.ubicacionesAll.map(ubi => {
            let x = `ubicacion_${ubi.id}`;

            const costo = this.items.find(
              i =>
                i.payload.actividad_id == act.id &&
                i.payload.ubicacion_id == ubi.id
            );

            ac = {
              ...ac,
              [x]: costo
                ? JSON.stringify({
                    id: costo.id,
                    costo: costo.payload.costo,
                    act_id: act.id,
                    ubi_id: ubi.id
                  })
                : JSON.stringify({
                    id: 0,
                    costo: 0,
                    act_id: act.id,
                    ubi_id: ubi.id
                  })
            };
            // this.actividades_costos.push({nombre: act.payload.nombre})
          });
          this.actividades_costo.push(ac);
        });
        console.log(this.actividades_costo);
      })
      .finally(() => (this.isLoading = false));
  },

  computed: {
    filteredItems() {
      return this.actividades_costo.filter(
        i =>
          i.nombre
            .toString()
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          i.unidad.toLowerCase().includes(this.filter.toLowerCase())
      );
    }
  },

  methods: {
    JsonParse(json) {
      if (json) return JSON.parse(json);
      else return {};
    },
    toggleSelect(id, costo, nombre, ubicacion, actId, ubiId) {
      this.modal = true;
      const itemIndex = {
        id: id,
        costo: costo,
        nombre: nombre,
        ubicacion: ubicacion,
        act_id: actId,
        ubi_id: ubiId
      };
      this.itemModal = itemIndex;
      this.costo = costo;
    },
    updateCosto() {
      this.isLoading = true;
      if (this.itemModal.id != 0) {
        this.$store
          .dispatch("customActualizarHTTP", {
            schema: "actividades_costos",
            id: this.itemModal.id,
            payload: {
              actividad_id: this.itemModal.act_id,
              ubicacion_id: this.itemModal.ubi_id,
              costo: Number(this.costo)
            }
          })
          .then(() => {
            const index = this.actividades_costo.findIndex(
              ac => ac.id == this.itemModal.act_id
            );

            let newString = JSON.parse(
              this.actividades_costo[index][
                `ubicacion_${this.itemModal.ubi_id}`
              ]
            );
            newString.costo = Number(this.costo);
            this.actividades_costo[index][
              `ubicacion_${this.itemModal.ubi_id}`
            ] = JSON.stringify(newString);
          })
          .catch(rej => {
            console.log(rej);
          })

          .finally(() => {
            this.isLoading = false;
            this.modal = false;
          });
      } else {
        this.$store
          .dispatch("customActualizarHTTP", {
            schema: "actividades_costos",
            payload: {
              actividad_id: this.itemModal.act_id,
              ubicacion_id: this.itemModal.ubi_id,
              costo: Number(this.costo)
            }
          })
          .then(res => {
            console.log(res.data);

            const index = this.actividades_costo.findIndex(
              ac => ac.id == this.itemModal.act_id
            );

            let newString = JSON.parse(
              this.actividades_costo[index][
                `ubicacion_${this.itemModal.ubi_id}`
              ]
            );
            newString.costo = Number(this.costo);
            newString.id = res.data.id;
            this.actividades_costo[index][
              `ubicacion_${this.itemModal.ubi_id}`
            ] = JSON.stringify(newString);
          })
          .catch(rej => {
            console.log(rej);
          })

          .finally(() => {
            this.isLoading = false;
            this.modal = false;
          });
      }
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
</style>
